<template>
  <v-app :dark="$store.state.appSettingsModule.appSettings.isDarkMode">
    <v-content>
      <router-view style="width: 100%; height: 100%;"></router-view>
    </v-content>
    <v-footer app :height="$vuetify.breakpoint.mdAndUp ? '100' : '20'">
      <status-bar />
    </v-footer>
    <v-dialog v-model="$store.state.popupDialogModule.popupVisible" persistent max-width="800">
      <v-card v-if="$store.state.popupDialogModule.popupVisible">
        <!-- <v-card-title class="headline">Error</v-card-title> -->
        <v-card-text :class="$vuetify.breakpoint.mdAndUp ? 'display-1' : ''">{{ $store.state.popupDialogModule.popupMessage }}</v-card-text>
        <v-card-actions v-if="$store.state.popupDialogModule.mode === 'ok'">
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" @click="hideDialog()">OK</v-btn>
        </v-card-actions>
        <v-card-actions v-else-if="$store.state.popupDialogModule.mode === 'yesNo'">
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" @click="$store.state.popupDialogModule.yesAction()">Yes</v-btn>
          <v-btn color="green darken-1" @click="hideDialog()">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import StatusBar from "@/components/StatusBar.vue";

@Component({
  components: { StatusBar }
})
export default class App extends Vue {
  name = "App"

  hideDialog() {
    this.$store.commit('popupDialogModule/MUTATE_POPUP_DIALOG_STATE', { key: 'popupVisible', value: false });
  }

  created() {
    console.log("app created");
    console.log(`counting appState on startup: ${this.$store.state.countModule.appState}`);
    this.$store.dispatch("restoreSession");
  }
}
</script>

<style>

.no-select {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome and Opera */
}

</style>

